import React, { useState, useEffect } from "react";
import '../../../styles/components/Hero.css';

const images = [
  "/images/hero/herosection1.png",
  "/images/hero/herosection2.png",
  "/images/hero/herosection3.png",
];

const Hero = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-slide effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 4000); // Change image every 4 seconds

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  return (
    <section className="hero">
      <div>
        <div className="logo-container">
          <img src={images[currentIndex]} alt="Logo" className="hero-logo"/>
        </div>
        <div className="hero-content" style={{ display: currentIndex === 0 ? "block" : "none" }}>
          <h1 className="hero-heading">Designing Your Digital Success</h1>
          <button className="hero-button">View More</button>
        </div>
      </div>

      {/* Carousel arrows */}
      <div className="carousel-controls">
        <span className="arrow left-arrow" onClick={prevSlide}>&lt;</span>
        <span className="arrow right-arrow" onClick={nextSlide}>&gt;</span>
      </div>
    </section>
  );
};

export default Hero;
